import { readPickerRecent, rememberPickerRecent } from '@atoms/PickerCombobox/pickerRecent';

const RECENT_LIMIT = 3;

const dictRecentStorageKey = (username: string, dictName: string) => `user-${username}.dictpickerRecent.${dictName}`;

/** Коды, выбранные из справочника последними (новые первыми). */
export const readDictRecentCodes = (username: string, dictName: string): string[] =>
    readPickerRecent(dictRecentStorageKey(username, dictName), RECENT_LIMIT);

export const rememberDictRecentCodes = (username: string, dictName: string, codes: string[]) =>
    rememberPickerRecent(dictRecentStorageKey(username, dictName), codes, RECENT_LIMIT);
